import { PresenterAssetCard } from '@/pages/AdvancedEditor/components/panels/avatars/PresenterAssetCard';
import { ImageType, Presenter } from '@d-id/types';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const PresenterSkeleton = styled(Skeleton)`
    aspect-ratio: 16/9;
    height: unset;
    position: relative;
    border-radius: 12px;
`;

interface Props {
    presenters?: Presenter[];
    onClick: (item: Presenter) => void;
    onRemove: (item: Presenter) => void;
    selected?: Presenter;
    skeletonAmount?: number;
}

export const PresentersList = ({ presenters, onClick, onRemove, selected, skeletonAmount = 29 }: Props) => {
    if (!presenters) {
        return (
            <>
                {Array.from({ length: skeletonAmount }, (_, index) => (
                    <PresenterSkeleton variant="rectangular" key={index} />
                ))}
            </>
        );
    }

    return (
        <>
            {presenters.map(presenter =>
                presenter.presenterType === ImageType.Skeleton ? (
                    <PresenterSkeleton key={presenter.id} variant="rectangular" />
                ) : (
                    <PresenterAssetCard
                        key={presenter.id}
                        presenter={presenter}
                        onClick={onClick}
                        onRemove={onRemove}
                        selected={selected}
                    />
                )
            )}
        </>
    );
};
